import {mapActions, mapState} from 'vuex'
import {getQuoteAllNew} from '@api/quote'

export default {
  data(){
    return{
      path:'',
    }
  },
  computed:{
    ...mapState('quote',['createQuoteForm']),
    carList(){
      return [
        {
          icon: 'briefcase',
          label: 'Contracts All Risks',
          path:'/create/sme/tickets',
          typeList: ['Company'],
          productId: 79
        },
      ]
    },
    list(){
      return  [
        {
          img: require('@/assets/images/quote/banner-motor.png'),
          productId: 11,
          label: 'Motorcycle',
          classId:14,
          typeList: ['Personal', 'Company'],
          logo: 'Motorcycle',
        },
        {
          img: require('@/assets/images/quote/banner-motor.png'),
          productId: 11,
          label: 'Private Car',
          logo: 'PrivateCar',
          classId:11,
          typeList: ['Personal', 'Company']
        },
        {
          img: require('@/assets/images/quote/banner-motor.png'),
          productId: 11,
          label: 'Commercial Vehicle',
          logo: 'CommercialVehicle',
          classId:12,
          typeList: ['Personal', 'Company']
        },
        {
          img: require('@/assets/images/quote/banner-housemaid.png'),
          productId: 12,
          label: 'Domestic Helper',
          logo: 'Housemaid',
          typeList: ['Personal'],
          classId:21,
        },

        {
          img: require('@/assets/images/quote/banner-home.png'),
          label: 'Home',
          logo: 'Home',
          typeList: ['Personal', 'Company'],
          productId: 17,
          classId:26,
        },
        {
          img: require('@/assets/images/quote/banner-fire.png'),
          label: 'Fire',
          logo: 'Fire',
          typeList: ['Personal', 'Company'],
          productId: 20,
          classId:29,
        },
        {
          img: require('@/assets/images/quote/banner-travel.png'),
          productId: 14,
          label: 'Travel',
          logo: 'Travel',
          typeList: ['Personal'],
          classId:23,
        },
        {
          img: require('@/assets/images/quote/banner-overseas-student.png'),
          label: 'Overseas Student',
          logo: 'OverseasStudent',
          typeList: ['Personal'],
          productId: 16,
          classId:25,
        },
        {
          img: require('@/assets/images/quote/banner-working.png'),
          productId: 13,
          label: 'Working Holiday',
          logo: 'WorkingHoliday',
          typeList: ['Personal'],
          classId:22,
        },
        {
          img: require('@/assets/images/quote/banner-personal-accident.png'),
          label: 'Personal Accident',
          logo: 'PersonlAccident',
          typeList: ['Personal'],
          productId: 18,
          classId:27,
        },
        {
          img: require('@/assets/images/quote/banner-interior.png'),
          label: 'Interior Decoration',
          typeList: ['Company'],
          productId: 15,
          classId:24,
        },

        {
          label: 'Pet Insurance',
          typeList: ['Personal'],
          logo: 'Pet',
          productId: 22,
          classId:31,
        },
        {
          label: 'Motor Trade',
          typeList: ['Personal'],
          logo: 'MotorTrade',
          productId: 11,
          classId:13,
        },
        {
          label: 'HZMB',
          typeList: ['Personal'],
          logo: 'hzmb',
          productId: 11,
          classId:15,
        }
        // {
        //   img: require('@/assets/images/quote/banner-exhibition.png'),
        //   label: 'Exhibition',
        //   typeList: ['Company'],
        //   productId: 20
        // }
      ]
    },
    isFina(){
      let path = this.$route.path
      return path.includes('/fina/')
    },
    smeList(){
      return [
        {
          icon: 'utensils',
          productId: 81,
          path:'/create/sme/tickets',
          label: 'Catering',
          typeList: ['Company']
        },
        {
          icon: 'door-closed',
          productId: 82,
          path:'/create/sme/tickets',
          label: 'Pure Office',
          typeList: ['Company']
        },


        {
          icon: 'store',
          label: 'Retail Shop',
          path:'/create/sme/tickets',
          typeList: ['Company'],
          productId: 83
        },

        //
        // {
        //   icon: 'spray-can-sparkles',
        //   label: 'Beauty Center',
        //   path:'beauty',
        //   typeList: [ 'Company'],
        //   productId: 84
        // },
        // {
        //   icon: 'scissors',
        //   label: 'Hair Salon',
        //   path:'hair',
        //   typeList: [ 'Company'],
        //   productId: 86
        // },
        // {
        //   icon: 'school',
        //   productId: 85,
        //   path:'education',
        //   label: 'Education Center',
        //   typeList: ['Company']
        // },
        // {
        //   icon: 'house-chimney-medical',
        //   label: 'Medical Center / Clinic',
        //   path:'medical',
        //   typeList: ['Company'],
        //   productId: 88
        // },
        {
          icon: 'comment-dots',
          label: 'Other',
          path:'/create/sme/tickets',
          typeList: ['Company'],
          productId: 89
        }
      ]
    },
    showKycForm(){
      return[
        {
          id:'isrd_title',
          name:'Title',
          type:1,
          option:this.titleOptions
        },
        {
          id:'isrd_lst_nm',
          name:'Last Name',
        },
        {
          id:'isrd_fst_nm',
          name:'First Name',

        },
        {
          id:'isrd_dob',
          name:'Date of Birth',

        },
        // {
        //   id:'id_type',
        //   name:'HKID'
        // },
        {
          id:'id_no',
          name:'ID Number'
        },
        {
          id:'isrd_com_nm',
          name:'Company Name',
        },
        {
          id:'bsns_nature_id',
          name:'Nature of Business',
        },
        {
          id:'address',
          name:'Address',
        },
        {
          id:'rgtn_no',
          name:'Registration Mark'
        },
        {
          id:'model_id',
          name:'Make'
        },
        {
          id:'make',
          name:'Make'
        },
        {
          id:'rgtn_mdl',
          name:'Model'
        },
        {
          id:'model',
          name:'Model'
        },
        {
          id:'typ_of_bdy_id',
          name:'Body Type'
        },
        {
          id:'typ_of_bdy',
          name:'Body Type'
        },
        {
          id:'rgtn_yr',
          name:'Year of Manufacture'
        },
        {
          id:'engn_cpcty',
          name:'Cylinder Capacity'
        },
        {
          id:'tonnage',
          name:'Permitted Gross Vehicle Weight'
        },
        {
          id:'no_of_seats',
          name:'Seating Capacity ( excl. driver)'
        },
        {
          id:'chasis_no',
          name:'Chassis Number'
        },        {
          id:'engn_no',
          name:'Engine Number'
        },

      ]
    },
  },
  methods: {
    ...mapActions('common', ['setProductId','setCarClassId']),
    ...mapActions('quote',['setQuoteForm','setAllQuote','setQuoteResult']),
    ...mapActions('account', ['setCustomerId','setSelectCustomerData','setReferCustomerId','setSelectReferCustomerData']),
    ...mapActions('coupon', ['setSelectCode','setCouponData','setReferrerData']),
    ...mapActions('smeQuote', ['setSmeQuickForm']),
    typeClick({ productId,path,classId },type) {
      let {hasCustomer} = this.$route.query||{}
      this.setReferrerData(null)
      if(productId) {
        this.setProductId(productId)
        this.setCarClassId(classId)
        this.formData.product_id = productId
        this.formData.class_id = classId
        this.formData.type = type
        this.setQuoteForm(null)
        if(!hasCustomer)
        {
          this.setCustomerId(null)
          this.setSelectCustomerData(null)
          this.setReferCustomerId(null)
          this.setSelectReferCustomerData(null)
        }

        this.setSelectCode(null)
        this.setCouponData(null)
      }
    },
    network() {
      return {
        // 采用新版報價接口
        getQuoteAllNew: async (params) => {
          params = {  class_id: 22}
          let query ={
            source:this.formData.ref_agency_id
          }
          const {data} = await getQuoteAllNew({  class_id: 22})
          this.setQuoteForm(params)

          if (!data.list || data.list.length < 1) {
            if (this.isReferralRequest) {
              this.$emit('refer')
              return
            }

            this.$router.push({
              name: 'quotingRefer',
              query: {
                product_id: this.productId,
                ...query
              }
            })
            return
          }

          this.setAllQuote(data.list)
          this.setQuoteResult(data)

          if (this.isReferralRequest) {
            this.$emit('success')
            return
          }
          this.$router.push(
            {
              path: `/quoting/${this.severType}/quote`,
              query: {...query,product_id: this.productId}
            }
          )
        }
      }
    },
  }
}